$(function(){
  $.nette.init(); // kvuli nette.ajax.js
  setupFormAjaxSpinner(); 
})

$spinnerHTML = '<div id="floatingCirclesG" class="form-spinner"><div class="f_circleG" id="frotateG_01"></div><div class="f_circleG" id="frotateG_02"></div><div class="f_circleG" id="frotateG_03"></div><div class="f_circleG" id="frotateG_04"></div><div class="f_circleG" id="frotateG_05"></div><div class="f_circleG" id="frotateG_06"></div><div class="f_circleG" id="frotateG_07"></div><div class="f_circleG" id="frotateG_08"></div></div>';
function setupFormAjaxSpinner() {  
  $.nette.ext('spinner', {
    init: function () {
      this.spinner = $($spinnerHTML);
    },
    start: function () {
      this.spinner = $($spinnerHTML);
      if (arguments[1].nette.e.target == arguments[1].nette.e.delegateTarget) {
        this.targetEl = $(arguments[1].nette.e.target).find('input[type=submit]');
      }
      else {
        this.targetEl = $(arguments[1].nette.e.target);
      }
      $parentEl = this.targetEl.closest('form').find('.submit-parent:visible');
      $parentEl.append(this.spinner);
      if(!$parentEl.hasClass('replace-submit')){
        this.spinner.css({top: ($parentEl.height() / 2) - (this.spinner.height() / 2), left: $parentEl.hasClass('width-parent') ? $parentEl.width() + 5 : this.targetEl.width() + 5});
        if($parentEl.hasClass('to-left')) this.spinner.css({left: -this.spinner.width() - 5 - $parentEl.position().left + $parentEl.closest('form')});
        if($parentEl.hasClass('space-right'))
        {
          this.spinner.css({left: parseInt(this.spinner.css('left').substr(0, this.spinner.css('left').length - 2)) + 10});
        }
      }
      else {
        this.targetEl.hide();
        this.spinner.css({left: ($parentEl.width() / 2) - (this.spinner.width() / 2)});
      }
    },
    complete: function () {
      this.spinner.hide();
    }
  }, {
    spinner: null,
    targetEl: null
  });
}
